// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.00057 3.99951V1.99951H7.00057V3.99951H5.43437L1.23438 10.9995H22.7668L18.5668 3.99951H9.00057Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 12.9995H3V21.9995H8.50098V16H15.501V21.9995H21V12.9995Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10.501 18V22H13.501V18H10.501Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-houses-2-filled')
export default class Houses2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'houses-2-filled',
    }
  }
}
